/* Visibility only: native and multi-shade carts retain their existing handlers. */
(() => {
  if (customElements.get('pb-cro-sticky-watch')) return;
  customElements.define('pb-cro-sticky-watch', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-pb-sticky-root]');
      this.variantEvent = `eurus:product-page-variant-select:updated:${this.dataset.section}`;
      this.nativeForms = () => ['product-form-', 'product-form-installment-', 'product-form-sticky-']
        .map(prefix => document.getElementById(prefix + this.dataset.section)).filter(Boolean);
      this.onVariant = event => {
        if (this.root?.querySelector('pb-card-shades[data-mode="pdp"]')) return;
        const data = event.detail?.html?.querySelector('.variant-selects-main [data-selected-variant]');
        if (!data) return;
        let variant;
        try { variant = JSON.parse(data.textContent); } catch (_) { return; }
        // Eurus replaces buy-button markup after updating form inputs. Restore
        // the resolved ID on the final forms, without replacing its cart handler.
        for (const form of this.nativeForms()) {
          const input = form.querySelector('input[name="id"]');
          if (input) {
            input.value = variant?.id ? String(variant.id) : '';
            input.setAttribute('value', input.value);
          }
        }
        this.pendingVariant = !variant?.id;
      };
      this.onChange = event => {
        if (this.root?.querySelector('pb-card-shades[data-mode="pdp"]')) return;
        if (!event.target.matches('select, input[type="radio"]')) return;
        if (!event.target.closest('.variant-selects-main, [id^="variant-update-sticky-"]')) return;
        this.pendingVariant = true;
      };
      this.guardPending = event => {
        if (!this.pendingVariant) return;
        const form = event.target.closest('form');
        if (!this.nativeForms().includes(form)) return;
        if (event.type === 'click' && !event.target.closest('.add_to_cart_button')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      };
      document.addEventListener(this.variantEvent, this.onVariant);
      this.root?.addEventListener('change', this.onChange, true);
      this.root?.addEventListener('click', this.guardPending, true);
      this.root?.addEventListener('submit', this.guardPending, true);
      this.update = () => {
        const source = this.root?.querySelector('pb-card-shades[data-mode="pdp"] .pb-cro-card-shades__trigger')
          || this.root?.querySelector(`#product-form-${CSS.escape(this.dataset.section)} .add_to_cart_button`);
        const visible = !!source && source.getBoundingClientRect().bottom < 0;
        window.dispatchEvent(new CustomEvent('pb-cro-sticky-visibility', {detail: {section: this.dataset.section, visible}}));
      };
      this.onScroll = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      };
      window.addEventListener('scroll', this.onScroll, {passive:true});
      window.addEventListener('resize', this.onScroll);
      window.addEventListener('load', this.onScroll);
      this.onScroll();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      window.removeEventListener('load', this.onScroll);
      document.removeEventListener(this.variantEvent, this.onVariant);
      this.root?.removeEventListener('change', this.onChange, true);
      this.root?.removeEventListener('click', this.guardPending, true);
      this.root?.removeEventListener('submit', this.guardPending, true);
      cancelAnimationFrame(this.frame);
    }
  });
})();
